import { render } from "./ViewAddPaymentProcessors.vue?vue&type=template&id=3853266a"
import script from "./ViewAddPaymentProcessors.vue?vue&type=script&lang=js"
export * from "./ViewAddPaymentProcessors.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/ardia/V3/v2026.29.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__